



















































import { defineComponent, reactive, PropType, ref, onMounted } from '@vue/composition-api';
import { useAsyncState } from '@vueuse/core';
import http from 'common-module/src/util/http';
import { useLocale } from '../../hooks/useLocale';
import { useMessage } from '../../hooks/useMessage';
import { Message } from '../../dataType';
import { Message as ZKMessage } from 'zk-ui';
export default defineComponent({
  name: 'FeedbackDialog',
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { t } = useLocale();
    const { prevMessage } = useMessage();
    const input = ref();
    const prevMsg = prevMessage(props.message.id, (item) => item.type === 'ai.sendText');
    const choiceList = [{
      label: t('saas.robotChat.reaction.feedbackDialog.typeOptions1'),
      value: 'option-1'
    }, {
      label: t('saas.robotChat.reaction.feedbackDialog.typeOptions2'),
      value: 'option-2'
    }, {
      label: t('saas.robotChat.reaction.feedbackDialog.typeOptions3'),
      value: 'option-3'
    }, {
      label: t('saas.robotChat.reaction.feedbackDialog.typeOther'),
      value: 'other'
    }];
    const vo = reactive({
      choiceContent: 'option-1',
      msgContent: ''
    });

    const { isLoading, execute } = useAsyncState(() => http.post('/chat/feedback', {
      ...vo,
      feedbackMsgId: props.message.id,
      keyword: prevMsg?.content || '',
      intendType: props.message.intentCode || ''
    }), null, { immediate: false });

    onMounted(() => {
      setTimeout(() => {
        input.value?.focus();
      }, 100);
    });

    const submit = async () => {
      await execute();
      ZKMessage.success(t('saas.robotChat.reaction.feedbackDialog.success'));
      emit('submit', choiceList.find(item => item.value === vo.choiceContent)?.label);
    };
    const close = () => {
      emit('close');
    };
    return {
      vo,
      t,
      input,
      choiceList,
      isLoading,
      submit,
      close
    };
  }
});
